<div class="container-modal">
    <div class="header-modal">
        <h1 class="text-color-primary"><strong>{{'direccion-envio.titulo' | translate}}</strong></h1>
        <button mat-icon-button (click)="cerrarModal()" class="btn-icon-cerrar">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <div class="body-modal">
        <div id="content-portada-modal">
            <div id="lado-text-portada">
                <h2 class="text-color-primary" [innerHTML]="'direccion-envio.titulo.detalle' | translate"></h2>
                <P class="" [innerHTML]="'direccion-envio.subtitulo.detalle' | translate"></P>
            </div>
            <div id="lado-imagen-portada">
                <img src="assets/images/dossier.png" alt="">
            </div>
        </div>
        <div class="content-form-envio" [formGroup]="formDireccionEnvio">
            <p class="txt-small">{{'direccion-envio.titulo.formulario' | translate}}</p>
            <div class="form-control envio-direccion-form mt-0 mb-0">
                <label for="envio-direccion" class="form-label-row ">{{'direccion-envio.direccion' | translate}}</label>
                <input type="text" class="campos mat-mdc-form-field" id="envio-direccion"
                    formControlName="direccion" placeholder="Dirección" class="input-form-control w-100">
                <div *ngIf="getFormDireccionEnvio['direccion'].errors" class="content-validacion-form mt-0">
                    <div>{{getError(getFormDireccionEnvio['direccion'])}}</div>
                </div>
            </div>
            <div class="row">
                <div class="form-control envio-direccion-form mt-0 mb-0 col-6">
                    <label for="envio-provincia" class="form-label-row ">{{'direccion-envio.provincia' | translate}}</label>
                    <input type="text" class="campos mat-mdc-form-field" id="envio-provincia"
                        formControlName="provincia" placeholder="Provincia" class="input-form-control w-100">
                    <div *ngIf="getFormDireccionEnvio['provincia'].errors" class="content-validacion-form mt-0">
                        <div>{{getError(getFormDireccionEnvio['provincia'])}}</div>
                    </div>
                </div>
                <div class="form-control envio-direccion-form mt-0 mb-0 col-6">
                    <label for="envio-ciudad" class="form-label-row ">{{'direccion-envio.ciudad' | translate}}</label>
                    <input type="text" class="campos mat-mdc-form-field" id="envio-ciudad"
                        formControlName="ciudad" placeholder="Ciudad" class="input-form-control w-100">
                    <div *ngIf="getFormDireccionEnvio['ciudad'].errors" class="content-validacion-form mt-0">
                        <div>{{getError(getFormDireccionEnvio['ciudad'])}}</div>
                    </div>
                </div>
                <div class="form-control envio-direccion-form mt-0 mb-0 col-6">
                    <label for="envio-cp" class="form-label-row ">{{'direccion-envio.codigo-postal' | translate}}</label>
                    <input type="text" class="campos mat-mdc-form-field" id="envio-cp"
                        formControlName="codigoPostal" placeholder="Código Postal" class="input-form-control w-100">
                    <div *ngIf="getFormDireccionEnvio['codigoPostal'].errors" class="content-validacion-form mt-0">
                        <div>{{getError(getFormDireccionEnvio['codigoPostal'])}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="content-validacion-form-general text-center mb-1">
            <span>{{mensajeValidacionForm}}</span>
        </div>
        
    </div>
    <div class="footer-modal">
        <div id="content-envio-footer" class="text-end">
            <button class="btn-primary" (click)="cerrarModalEnvio()">{{'direccion-envio.aceptar' | translate}}</button>
        </div>
    </div>
</div>